import { render, staticRenderFns } from "./competitionIndex.vue?vue&type=template&id=22899640&scoped=true&"
import script from "./competitionIndex.vue?vue&type=script&lang=js&"
export * from "./competitionIndex.vue?vue&type=script&lang=js&"
import style0 from "./competitionIndex.vue?vue&type=style&index=0&id=22899640&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22899640",
  null
  
)

export default component.exports